import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

export function Spinner({
  size = 24,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <Loader2
      size={size}
      className={cn("animate-spin text-leaf-green-ink", className)}
    />
  );
}

export function LoadingBlock({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-night-blue/70">
      <Spinner size={32} />
      <p className="font-condensed uppercase tracking-widest text-xs">
        {label}
      </p>
    </div>
  );
}
